// extracted by mini-css-extract-plugin
module.exports = {"section_terms_hero":"hero_section_terms_hero__LjyAK","title_wrapper":"hero_title_wrapper__D92od","sub_text":"hero_sub_text__cI_u7"};